export function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  isDarkMode = false,
  ...props
}) {
  return (
    <div className="mb-4">
      <label htmlFor={name} className="block text-sm font-semibold mb-2" style={{ color: isDarkMode ? '#e2e8f0' : '#333333' }}>
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`input-field ${error ? 'border-red-500' : ''}`}
        {...props}
      />
      {error && <p className="text-sm mt-1" style={{ color: isDarkMode ? '#fca5a5' : '#ef4444' }}>{error}</p>}
    </div>
  )
}
